import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'greener-ui-library';

interface InstructionModalProps {
  /** Button trigger element */
  trigger: ReactNode;
  /** Modal title */
  title: string;
  /** Modal content */
  children: ReactNode;
  /** Whether modal is open */
  open: boolean;
  /** Callback when modal should close */
  onClose: () => void;
}

export const InstructionModal = ({ trigger, title, children, open, onClose }: InstructionModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      {trigger}
      <Modal
        title={title}
        isOpen={open}
        onClose={onClose}
        onPrimaryButtonClick={onClose}
        primaryButtonTitle={t('components:form.close')}
        data-testid="instruction-modal"
      >
        {children}
      </Modal>
    </>
  );
};
